function explodeCSVAndGetObjectsFromLookup(csvString, lookup) {
  if (!csvString) return [];
  const values = csvString
    .split(',')
    .map(v => v.trim())
    .filter(Boolean);
  return lookup.filter(opt => values.includes(opt.value));
}

export default explodeCSVAndGetObjectsFromLookup;
